  import { stats } from 'instantsearch.js/es/widgets';
  import { getInstance, registerWidget } from './algolia-create-instance';
  import { renderStatsTemplate as fallbackTemplate } from "../../stats-templates/default-template.js"

  document.addEventListener("DOMContentLoaded", function() {

    const tgblAlgoliaFrontend_json = window.atob(tgblAlgoliaFrontend_e);
    const tgblAlgoliaFrontend = jQuery.parseJSON(tgblAlgoliaFrontend_json);
    const LOCALIZED = tgblAlgoliaFrontend.localized;

    // Get all elements with refinement list class
    // const elements = Array.from(document.getElementsByClassName("algolia-stats"));
    const elements = document.querySelectorAll("[data-filter-type='stats']")
    const elementsArray = Array.from(elements);
    
    // Group together refinement list elements that share an index
    const elementsGroupedByIndex = elementsArray.reduce((acc, element) => {
      const dataIndexValue = element.getAttribute("data-index");
      if (!acc[dataIndexValue]) {
        acc[dataIndexValue] = [];
      }
      acc[dataIndexValue].push(element);
      return acc;
    }, {});

    // Loop through each index
    for (const dataIndexValue in elementsGroupedByIndex) {
      if (elementsGroupedByIndex.hasOwnProperty(dataIndexValue)) {
        const elementsWithSameIndex = elementsGroupedByIndex[dataIndexValue];
        let search = getInstance(dataIndexValue);

        // Perform actions on elements with the same data-index value
        elementsWithSameIndex.forEach(async element => {

          let renderStatsTemplate = fallbackTemplate
          let templatePath = element.getAttribute("data-template")

          if(templatePath) {
            try{
              const module = await import(templatePath)
              renderStatsTemplate = module.default || module.renderStatsTemplate
            } catch (error) {
              console.error(`Error loading template from ${templatePath}:`, error)
            }
          } 

          let AlgoliaStats = ($, search, element) => {
            search.addWidgets([
              stats({
                container: element,
                templates: {
                  text: renderStatsTemplate,
                },
              })
            ]);
            registerWidget(element);
          };
          AlgoliaStats($, search, element);
        });
      }
    }
  });